if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMediaId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        const slides = Array.from(this.querySelectorAll('.product-media-modal__slide'));

        if (!slides.length) return;

        this.querySelectorAll('.product-media-modal__slide .active').forEach((element) => {
          element.classList.remove('active');
        });

        let activeSlide = slides.find((slide) => slide.dataset.mediaId === activeMediaId);

        if (!activeSlide) {
          activeSlide = slides[0];
        }

        slides.forEach((slide) => {
          slide.classList.toggle('active', slide === activeSlide);
        });

        const sliderComponent = this.querySelector('slider-component');
        if (sliderComponent && activeSlide) {
          if (typeof sliderComponent.resetPages === 'function') {
            sliderComponent.resetPages();
          }

          const scrollTarget = activeSlide.offsetLeft;

          if (typeof sliderComponent.setSlidePosition === 'function') {
            sliderComponent.setSlidePosition(scrollTarget);
            if (typeof sliderComponent.update === 'function') {
              sliderComponent.update();
            }
          } else {
            const sliderTrack = sliderComponent.querySelector('.product-media-modal__media-list');
            sliderTrack?.scrollTo({ left: scrollTarget });
          }
        }

        const targetMediaId = activeSlide ? activeSlide.dataset.mediaId : null;
        const activeMedia = targetMediaId
          ? activeSlide.querySelector(`[data-media-id="${targetMediaId}"]`)
          : null;
        const activeMediaTemplate = activeMedia?.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (activeMedia) {
          activeMedia.classList.add('active');
          activeSlide.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }

        if (
          activeMedia &&
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
